//#region src/utils.ts
/**
* Maps the values of a record, returning a new record with the same keys.
*
* @example
* mapRecord({ a: 1, b: 2 }, v => v * 2) // { a: 2, b: 4 }
*/
const mapRecord = (record, fn) => Object.fromEntries(Object.entries(record).map(([key, value]) => [key, fn(value, key)]));
/**
* Filters a record by value, returning a new record containing only entries
* where the predicate returns true.
*
* @example
* filterRecord({ a: 1, b: 2, c: 3 }, v => v > 1) // { b: 2, c: 3 }
*/
const filterRecord = (record, predicate) => Object.fromEntries(Object.entries(record).filter(([key, value]) => predicate(value, key)));
//#endregion
export { filterRecord, mapRecord };

//# sourceMappingURL=index.mjs.map